import { Button, useMediaQuery, useTheme } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

export const ButtonNavbar = ({ 
  children, 
  hasDropdown = false, 
  onClick 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <Button
      color="inherit"
      sx={{
        textTransform: "none",
        fontWeight: "normal",
        fontSize: {
          xs: "11px", // mobile
          sm: "12px", // tablet
          md: "14px", // desktop
        },
        px: {
          xs: 1, // mobile
          sm: 1.5, // tablet
          md: 2, // desktop
        },
        minWidth: 'auto',
      }}
      endIcon={hasDropdown ? <KeyboardArrowDown /> : null}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
